export default {};
throw new Error(`Could not resolve "kerberos" imported by "proxy-agent-negotiate". Is it installed?`)